<template>
  <button type="button" class="base-info-btn" :class="className">
    {{ buttonLabel }}
  </button>
</template>

<script>

export default {
  name: "BaseInfoButton",
  props: {
    collapseId: {
      type: String,
      required: true
    },
    labels: {
      type: Object,
      default: () => ({open: 'info', close: 'close'})
    }
  },

  data: () => ({
    buttonExpanded: false,
  }),

  computed: {
    buttonLabel() {
      return this.buttonExpanded ? this.labels.close : this.labels.open;
    },
    className() {
      return this.buttonExpanded ? 'expanded' : '';
    }
  },

  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === this.collapseId) {
        this.buttonExpanded = isJustShown;
      }
    });
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";

.base-info-btn {
  background-color: $c_blue;
  color: $c_white;
  border-radius: 50%;
  text-transform: uppercase;
  @include font-10-md;
  //margin-left: auto;
  width: 36px;
  height: 36px;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  @include media-breakpoint-down(md) {
    position: fixed;
    right: 20px;
    bottom: 20px;
  }

  &.expanded {
    background-color: $c_danger;
    color: $c_white;
  }

  &:hover {
    @include media-breakpoint-up(lg) {
      background-color: $c_white;
      color: $c_base;
    }
  }
}

</style>
